export const STORY_TEMPLATES = {
  default: 'default',
  campaignGridItems: 'campaign_grid_items',
  campaignGroups: 'campaign_groups',
};
